import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppConstants } from '../core/app.constants';

export class AnalisiTicketProject {
    id: number;
    key: string;
    name: string;
    prefix: string;
    archived: boolean;
}

export class AnalisiTicketProjectsResponse {
    status: number;
    message: string;
    projects: AnalisiTicketProject[];
    /** progetti selezionati all'apertura della pagina */
    defaultProjectIds: number[];
    /** nomi dei tipi issue per il filtro Tipi issue */
    issueTypes: string[];
}

export class AnalisiTicketGroup {
    name: string;
    values: number[];
    total: number;
}

export class AnalisiTicketUser {
    username: string;
    name: string;
}

export class AnalisiTicketResult {
    title: string;
    /** issue oppure ore */
    unit: string;
    /** intestazione della colonna dei gruppi, vuota per la vista complessiva */
    groupHeader: string;
    categories: string[];
    groups: AnalisiTicketGroup[];
    total: number;
    /** spiegazione del report: criteri di inclusione e significato delle categorie */
    notes: string[];
    /** solo Issue lavorate per utente: tutti gli utenti del report con gli altri filtri */
    users: AnalisiTicketUser[];
}

export class AnalisiTicketResponse {
    status: number;
    message: string;
    result: AnalisiTicketResult;
}

/** Filtri dei report Analisi Ticket (SIT-1836, SIT-1875), date nel formato yyyy-MM-dd */
export class AnalisiTicketRequest {
    report: string;
    projectIds: number[];
    /** nomi dei tipi issue, null = tutti i tipi */
    issueTypes: string[];
    /** solo Issue lavorate per utente: username, null = tutti gli utenti */
    users: string[];
    dateFrom: string;
    dateTo: string;
    /** TOTAL, PROJECT, USER o ISSUETYPE */
    groupBy: string;
    maxLifeDays: number;
}

@Injectable()
export class AnalisiTicketService {

    constructor(private http: Http) { }

    getProjects(srmToken: string): Observable<AnalisiTicketProjectsResponse> {
        const url = AppConstants.urlForNoCache(environment.REST_SERVICE_BASE_URL + "/analisiticket/projects");
        const headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.get(url, { headers: headers }).map(res => res.json());
    }

    getReport(srmToken: string, request: AnalisiTicketRequest): Observable<AnalisiTicketResponse> {
        const url = environment.REST_SERVICE_BASE_URL + "/analisiticket";
        const headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        headers.append('Content-Type', 'application/json');
        return this.http.post(url, JSON.stringify(request), { headers: headers }).map(res => res.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/service/analisi-ticket.service.ts